import React, { useEffect, useState } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import SmallLoader from "../../Common/smallLoader";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function BrokerageTable() {
  const storeToken = localStorage.getItem("ssoToken");
  const [brokerageData, setBrokerageData] = useState();
  const [loader, setLoader] = useState(true);
  let clientCode = "";

  function smartRoundToTwoDecimals(str) {
    str = str.trim();

    if (str.includes(".")) {
      // If decimals are only zeros → force 2 decimals
      if (/^(\d+)\.0+$/.test(str)) {
        return Number(str).toFixed(2);
      }
      // Otherwise keep as is (remove only trailing zeros if any)
      return str.replace(/(\.\d*?[1-9])0+$/g, "$1");
    } else {
      return str;
    }
  }

  const getClientBrokerage = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const clientBrokerageData = await axiosInstance.post(
        DASHBOARD_CLIENT_OVERVIEW.ClientBrokerage_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(clientBrokerageData?.data);
      const resp = res.data;
      let firstElementKey = Object.keys(resp)[0];
      setBrokerageData(resp[firstElementKey]);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getClientBrokerage(clientCode);
    }
  }, []);

  return (
    <div className="card-box brokerage-table bottom-25">
      <div className="card-title">
        <h2>{Constants.Client_Brokerage}</h2>
      </div>
      {/* {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <> */}
      {/* {summaryData == undefined || summaryData.length <= 0 ? (
                noDataFound()
              ) : (
                <> */}

      <div className="scroll-table">
        <table className="client-brokerage-table">
          <tr>
            <th rowspan="2"> Transaction Type</th>

            <th colspan="4">Equity Cash</th>
            <th colspan="3">Equity F&O</th>
          </tr>
          <tr>
            <th colspan="2">
              {brokerageData
                ? brokerageData?.type === "hni"
                  ? Constants.Intraday_Text
                  : Constants.Intraday
                : Constants.Intraday_Text}
            </th>
            <th colspan="2">
              {brokerageData
                ? brokerageData?.type === "hni"
                  ? Constants.Delivery_Text
                  : Constants.Delivery
                : Constants.Delivery_Text}
            </th>
            <th colspan="1">
              {brokerageData
                ? brokerageData?.type === "hni"
                  ? Constants.Futures_Text
                  : Constants.Futures
                : Constants.Futures_Text}
            </th>
            <th colspan="1">
              {brokerageData
                ? brokerageData?.type === "hni"
                  ? Constants.Options_Text
                  : Constants.Options
                : Constants.Options_Hni}
            </th>
            <th colspan="1">
              {brokerageData
                ? brokerageData?.type === "hni"
                  ? Constants.Index_Option_Text
                  : Constants.Index_Option
                : Constants.Index_Option_Hni}
            </th>
          </tr>

          <tr>
            <td rowspan="2">Brokerage Rate</td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.intraday ? (
                    brokerageData?.intraday.includes("P") ? (
                      <>
                        {smartRoundToTwoDecimals(
                          brokerageData?.intraday.split("P")[0]
                        )}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {smartRoundToTwoDecimals(
                          brokerageData?.intraday.split("V")[0]
                        )}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.delivery ? (
                    brokerageData?.delivery.includes("P") ? (
                      <>
                        {smartRoundToTwoDecimals(
                          brokerageData?.delivery.split("P")[0]
                        )}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {smartRoundToTwoDecimals(
                          brokerageData?.delivery.split("V")[0]
                        )}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="1">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.futures ? (
                    brokerageData?.futures.includes("P") ? (
                      <>
                        {smartRoundToTwoDecimals(
                          brokerageData?.futures.split("P")[0]
                        )}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {smartRoundToTwoDecimals(
                          brokerageData?.futures.split("V")[0]
                        )}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="1">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.options ? (
                    brokerageData?.options.includes("P") ? (
                      <>
                        {smartRoundToTwoDecimals(
                          brokerageData?.options.split("P")[0]
                        )}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {smartRoundToTwoDecimals(
                          brokerageData?.options.split("V")[0]
                        )}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="1">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.indexOptions ? (
                    brokerageData?.indexOptions.includes("P") ? (
                      <>
                        {smartRoundToTwoDecimals(
                          brokerageData?.indexOptions.split("P")[0]
                        )}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {smartRoundToTwoDecimals(
                          brokerageData?.indexOptions.split("V")[0]
                        )}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
          </tr>
        </table>
      </div>

      {/* </>
              )} */}
      {/* </>
          )} */}
    </div>
  );
}
export default BrokerageTable;
